var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContractsStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 47.04H5.99996C5.70146 47.04 5.45996 46.7985 5.45996 46.5V44.04H2.99996C2.70146 44.04 2.45996 43.7985 2.45996 43.5V41.04H1.49996C1.20146 41.04 0.959961 40.7985 0.959961 40.5V4.49996C0.959961 4.20146 1.20146 3.95996 1.49996 3.95996H8.45996V2.99996C8.45996 2.70146 8.70146 2.45996 8.99996 2.45996H11.46V1.49996C11.46 1.20146 11.7015 0.959961 12 0.959961H18C18.2985 0.959961 18.54 1.20146 18.54 1.49996V2.45996H21C21.2985 2.45996 21.54 2.70146 21.54 2.99996V3.95996H28.5C28.7985 3.95996 29.04 4.20146 29.04 4.49996V6.95996H31.5C31.7985 6.95996 32.04 7.20146 32.04 7.49996V9.95996H34.5C34.7985 9.95996 35.04 10.2015 35.04 10.5V46.5C35.04 46.7985 34.7985 47.04 34.5 47.04ZM6.53996 45.96H33.96V11.04H32.04V43.5C32.04 43.7985 31.7985 44.04 31.5 44.04H6.53996V45.96ZM3.53996 42.96H30.96V8.03996H29.04V40.5C29.04 40.7985 28.7985 41.04 28.5 41.04H3.53996V42.96ZM2.03996 39.96H27.96V5.03996H21.54V5.99996C21.54 6.29846 21.2985 6.53996 21 6.53996H8.99996C8.70146 6.53996 8.45996 6.29846 8.45996 5.99996V5.03996H2.03996V39.96ZM9.53996 5.45996H20.46V3.53996H18C17.7015 3.53996 17.46 3.29846 17.46 2.99996V2.03996H12.54V2.99996C12.54 3.29846 12.2985 3.53996 12 3.53996H9.53996V5.45996ZM24.75 32.04H5.24996V30.96H24.75V32.04ZM24.75 26.04H5.24996V24.96H24.75V26.04ZM24.75 20.04H5.24996V18.96H24.75V20.04ZM24.75 14.04H5.24996V12.96H24.75V14.04Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsStack);
export default __webpack_public_path__ + "static/media/contracts_stack.89ad954fae9ec06a61524207b08e38c6.svg";
export { ForwardRef as ReactComponent };